import { SiteLocale } from "src/__generated__/graphql";

export const getBlogPath = (locale: SiteLocale, routeName: string) => {
	return `/${locale}/blog/${routeName}/`;
};
